// extracted by mini-css-extract-plugin
export var avatar = "_l1-3";
export var avatarContainer = "_l1-2";
export var avatarSpacer = "_l1-5";
export var avatarSpacerContainer = "_l1-4";
export var avatarStackContainer = "_l1-1";
export var bubble = "_l1-0";
export var remainderBubble = "_l1-6";